<template>
  <div class="email-form">
    <form ref="emailBox" @submit.prevent="onSubscribe()" _u_id_name_="email">
      <div class="email-box">
        <input type="email" placeholder="Your email" v-model="email" class="email-input input" :class="[emailErrorMsg && 'error']" @focus="onFocus" />
        <button type="submit" class="email-input-submit">
          <template v-if="loading">
            <span class="loader tiny"></span>
          </template>
          <template v-else-if="!inputFocused && done">
            <checkmark />
          </template>
          <template v-else> Subscribe </template>
        </button>
      </div>
    </form>
    <span v-if="successMessage || emailErrorMsg" class="message" :class="[emailErrorMsg && 'error']">
      {{ successMessage || emailErrorMsg }}
    </span>
  </div>
</template>

<script>
import checkmark from '@/pixel/assets/icons/checkmark.svg';
import useNewsletter from '@/compositions/useNewsletter.js';
import Tracking from '@/components/commons/Tracking.js';

export default {
  name: 'EmailBoxForm',
  components: {
    checkmark,
  },
  props: {
    center: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputFocused: false,
      email: '',
      emailErrorMsg: '',
    };
  },
  setup() {
    function isValidEmail(email) {
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    const {
      subscribeUserEmail, //
      subscriptionResult,
      loading,
      called,
      done,
    } = useNewsletter();

    return {
      isValidEmail,
      subscribeUserEmail,
      subscriptionResult,
      loading,
      called,
      done,
    };
  },
  computed: {
    successMessage() {
      return this.done && this.subscriptionResult.success && this.subscriptionResult.message;
    },
  },
  methods: {
    onFocus() {
      this.inputFocused = true;
    },
    onSubscribe() {
      const email = this.email.trim();

      if (!this.email) {
        this.onValidationError('Please enter an email');
        return;
      }

      if (!this.isValidEmail(email)) {
        this.onValidationError('Please enter a valid email');
        return;
      }

      this.onSubmitEmail(email);
      this.inputFocused = false;
    },

    onValidationError(errMsg) {
      this.emailErrorMsg = errMsg;
      this.done = false;
    },
    onSubmitEmail(email) {
      this.emailErrorMsg = '';
      this.message = '';
      if (!this.called) {
        this.subscribeUserEmail({ email, subscriptionSource: 'Newsletter' });
        Tracking.heapIdentifyEmail(email);
      }
    },
  },
  watch: {
    done: {
      handler(done) {
        if (done && this.subscriptionResult.success) {
          this.email = '';
        }
      },
    },
  },
};
</script>

<style lang="postcss" scoped>
@import '@/pixel/style/variables';

.email-form {
  /* purgecss ignore */
  ::v-deep(svg path) {
    fill: white !important;
  }

  .email-input-submit {
    width: 100%;
    margin-top: var(--space-4);
  }

  @media (min-width: $tablet-breakpoint) {
    .email-box {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .email-input {
      width: 272px;
      min-width: 272px;
    }
    .email-input-submit {
      margin-left: 16px;
      margin-top: 0;
    }
  }
}
</style>
